import { CustomEventWithDetail } from 'rune-ts';

export class TabChangeEvent<T = any> extends CustomEventWithDetail<{ tabId: string } & T> {}
